module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contacts-uploader"
  }, [_c('modal', {
    attrs: {
      "title": _vm.modalTitle,
      "open": _vm.open,
      "saveText": _vm.modalSaveText
    },
    on: {
      "save": _vm.fileUpload,
      "cancel": _vm.cancel
    }
  }, [_c('div', {
    staticClass: "contacts-uploader-dropbox"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("ui.contacts.import.description")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.contacts.import.format")))]), _vm._v(" "), _c('div', {
    staticClass: "xls-upload"
  }, [_c('upload-field', {
    on: {
      "change": _vm.fileChange
    }
  })], 1), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "errors"
  }, [_c('span', {
    staticClass: "errors-icon"
  }, [_c('q-icon', {
    attrs: {
      "name": "error_outline"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "errors-msg"
  }, [_vm._v(_vm._s(_vm.error))])]) : _vm._e()])]), _vm._v(" "), (_vm.uploading) ? _c('div', {
    staticClass: "contacts-uploader-loader"
  }, [_c('loading')], 1) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "title": _vm.$t('ui.contacts.import.success_modal_title'),
      "open": _vm.importReportOpen,
      "cancelText": "",
      "saveText": "ui.global.ok"
    },
    on: {
      "save": function($event) {
        return _vm.importReportClose()
      },
      "cancel": function($event) {
        return _vm.importReportClose()
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('ui.contacts.import.success_modal_body')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.contacts.import.success_modal_report', {
    total: _vm.importReport.created_contacts + _vm.importReport.updated_contacts,
    new: _vm.importReport.created_contacts,
    updated: _vm.importReport.updated_contacts
  })))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ac39311","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/contacts/UploadContacts.vue
// module id = 1896
// module chunks = 0